import { __values } from "tslib";
import { isObject, isString } from '@slardar/sdk-core';
import { DEFAULT_BATCH_REPORT_WAIT, DEFAULT_MAX_BATCH_REPORT_LENGTH, DEFAULT_MAX_BREADCRUMBS, DEFAULT_PID, DEFAULT_REPORT_BATCH_PATH, DEFAULT_REPORT_DOMAIN, } from './constants';
import { generateSessionId, serialize } from './utils';
export function getDefaultConfig() {
    return {
        // MutableConfig
        context: {},
        // BatchProps
        maxBatchReportLength: DEFAULT_MAX_BATCH_REPORT_LENGTH,
        batchReportWait: DEFAULT_BATCH_REPORT_WAIT,
        // Common
        userId: '',
        sampleRate: 1,
        sessionId: generateSessionId(),
        reportDomain: DEFAULT_REPORT_DOMAIN,
        reportPath: DEFAULT_REPORT_BATCH_PATH,
        pid: DEFAULT_PID,
        maxBreadcrumbs: DEFAULT_MAX_BREADCRUMBS,
        // Flags
        hookPath: true,
        hookRequest: true,
        enableCapture: true,
    };
}
export function mergeUserConfig(target, source) {
    // TODO: filter propertyNames
    return Object.assign({}, target, source);
}
export function toClientConfig(defaultConfig, userConfig, extraConfig) {
    var e_1, _a;
    // TODO: filter propertyNames
    var res = Object.assign({}, defaultConfig, userConfig, extraConfig);
    // clone the user context and stringify its values
    var context = {};
    if (res.context && isObject(res.context)) {
        try {
            // stringify values in user context
            for (var _b = __values(Object.keys(res.context)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                var val = res.context[key];
                context[key] = isString(val) ? val : serialize(val);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    res.context = context;
    return res;
}
export function mergeClientConfig(target, source) {
    // TODO: filter propertyNames
    return Object.assign({}, target, source);
}
export function toBackendOptions(config) {
    return Object.assign({}, config);
}
//# sourceMappingURL=config.js.map